import { Tooltip } from '@lifebit-ai/lds'
import { DownloadFileMethods } from 'enums'
import React from 'react'

import { useDownloadFile } from 'services/results/hooks/useDownloadFile'

import { DownloadIcon, StyledLoader } from './DownloadResultFile.styles'
import { DOWNLOAD_FILE_ICON_TEST_ID } from './utils'

interface Props {
  resultId: string
  bucket: string
  fileKey: string
  fileName: string
  method?: DownloadFileMethods
}

const DownloadResultFile: React.FC<Props> = ({
  resultId,
  bucket,
  fileKey,
  fileName,
  method = DownloadFileMethods.DownloadInTabWithWindowOpen,
  ...rest
}) => {
  const mutation = useDownloadFile()

  // TODO/TBD: This is not in the designs. When downloading a file directly, an indicator should be displayed because
  //  the process can take a while for large files (though this method creates problems as the user is free to navigate
  //  when direct download is in progress).
  //  - toast.promise could be used to keep open the toast while downloading but is not avail in lds.
  //  - As a workaround, an inline loader is displayed in icon's place.
  if (mutation.isPending) return <StyledLoader text={false} />

  return (
    <Tooltip title="Download file">
      <DownloadIcon
        data-testid={DOWNLOAD_FILE_ICON_TEST_ID}
        onClick={() => mutation.mutate({ resultId, bucket, fileKey, fileName, method })}
        disabled={mutation.isPending}
        {...rest}
      />
    </Tooltip>
  )
}

export default DownloadResultFile
